export enum RiskTypeEnum {
  // Add your enum values here
  TYPE_A,
}
